import React from "react";
import {
  ContainerReports,
  ContainerIframe,
} from "./ReportsGamificationContainer.styled";

const ReportsGamificationContainer = () => {
  const iframe =
    '<iframe title="Gamification" src="https://app.powerbi.com/reportEmbed?reportId=d78999f7-d535-40a6-a8ec-cd1b45d24c92&autoAuth=true&ctid=638fcbaf-ba4c-43e1-adae-5475c970fe10" style="border: 0px; overflow: hidden; width: 100%; height: 100%; min-height: 610px;"></iframe>';

  return (
    <ContainerReports>
      <ContainerIframe
        contentEditable="true"
        dangerouslySetInnerHTML={{ __html: iframe }}
      ></ContainerIframe>
    </ContainerReports>
  );
};

export default ReportsGamificationContainer;
